import React from 'react'
import { Link } from 'gatsby'

const WallOfLove = () => {
  return (
    <div>
      <div className="text-center pt-6">
        <h1 className="py-6 text-center text-grey-darkest text-3xl font-bold">
          What our community is saying
        </h1>
        <br />
        {/* <div className="text-xl">What our community is saying</div> */}
      </div>

      <div className="flex justify-center flex-wrap p-6">
        {/* <div className="p-6  w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 text-center justify-center">
          <blockquote className="twitter-tweet m-auto" data-lang="en">
            <p lang="en" dir="ltr">
              I am always uber excited when I get this newsletter. Thank you for
              this gem,{' '}
              <a href="https://twitter.com/venikunche?ref_src=twsrc%5Etfw">
                @venikunche
              </a>
              ! Diversify Tech Issue #47:{' '}
              <a href="https://t.co/ZxQOILsJ8X">https://t.co/ZxQOILsJ8X</a>{' '}
              <a href="https://twitter.com/hashtag/100daysofcode?src=hash&amp;ref_src=twsrc%5Etfw">
                #100daysofcode
              </a>
            </p>
            &mdash; side-eye (@Tanzi_Chy){' '}
            <a href="https://twitter.com/Tanzi_Chy/status/1139338455065014272?ref_src=twsrc%5Etfw">
              June 14, 2019
            </a>
          </blockquote>
        </div> */}
        <div className="p-6  w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 px-4">
          <blockquote className="twitter-tweet m-4" data-lang="en">
            <p lang="en" dir="ltr">
              I found my new job because it was posted on{' '}
              <a href="https://twitter.com/venikunche?ref_src=twsrc%5Etfw">
                @venikunche
              </a>
              ’s DiversifyTech website/newsletter. Thank goodness for her
              dedicated work! All of you out there who identify with
              underrepresented groups in tech, check it out.
            </p>
            &mdash; Emily Jennings (@Phillylosophy){' '}
            <a href="https://twitter.com/Phillylosophy/status/1137712367494684673?ref_src=twsrc%5Etfw">
              June 9, 2019
            </a>
          </blockquote>
        </div>
        <div className="p-6  w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 px-4">
          <blockquote className="twitter-tweet" data-lang="en">
            <p lang="en" dir="ltr">
              grateful to{' '}
              <a href="https://twitter.com/venikunche?ref_src=twsrc%5Etfw">
                @venikunche
              </a>
              &#39;s weekly newsletter where I learned about the oppoortunity to
              apply to{' '}
              <a href="https://twitter.com/dinosaur_js?ref_src=twsrc%5Etfw">
                @dinosaur_js
              </a>{' '}
              🤗 just got an email yesterday that I received a full scholarship
              to attend! 🎉😭🙏✨
            </p>
            &mdash; Elaine Yeung (@egsy){' '}
            <a href="https://twitter.com/egsy/status/1135958803986493440?ref_src=twsrc%5Etfw">
              June 4, 2019
            </a>
          </blockquote>
        </div>
        <div className="p-6  w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 px-4">
          <blockquote className="twitter-tweet">
            <p lang="en" dir="ltr">
              Just got this week&#39;s issue of{' '}
              <a href="https://twitter.com/DiversifyTechCo?ref_src=twsrc%5Etfw">
                @DiversifyTechCo
              </a>
              , A++ I enthusiastically recommend! Job listings, speaking
              opportunities, events you might want to attend!
            </p>
            &mdash; ReneeData (@DataRenee){' '}
            <a href="https://twitter.com/DataRenee/status/1164294702847451137?ref_src=twsrc%5Etfw">
              August 21, 2019
            </a>
          </blockquote>{' '}
          <script
            async
            src="https://platform.twitter.com/widgets.js"
            charSet="utf-8"
          />
          {/* <blockquote class="twitter-tweet" data-cards="hidden" data-lang="en">
            <p lang="en" dir="ltr">
              Yeessss! got an email and I’m so thrilled to know I was selected
              for this year’s{' '}
              <a href="https://twitter.com/defcon?ref_src=twsrc%5Etfw">
                @defcon
              </a>{' '}
              conference courtesy of the amazing people at{' '}
              <a href="https://twitter.com/wisporg?ref_src=twsrc%5Etfw">
                @wisporg
              </a>{' '}
              and{' '}
              <a href="https://twitter.com/DiversifyTechCo?ref_src=twsrc%5Etfw">
                @DiversifyTechCo
              </a>
              . Thank YOU for the opportunity !! 💃💃🙏🏾 This will be my first
              time @ DEFCON. 🤞🏾 for plans{' '}
              <a href="https://twitter.com/HackathonGirls?ref_src=twsrc%5Etfw">
                @HackathonGirls
              </a>{' '}
            </p>
            &mdash; Juma Baldeh (@TechAngelGirl){' '}
            <a href="https://twitter.com/TechAngelGirl/status/1136055834331504640?ref_src=twsrc%5Etfw">
              June 4, 2019
            </a>
          </blockquote> */}
        </div>

        <div className="p-6  w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 px-4">
          <blockquote className="twitter-tweet" data-cards="hidden" data-lang="en">
            <p lang="en" dir="ltr">
              <a href="https://twitter.com/venikunche?ref_src=twsrc%5Etfw">
                @venikunche
              </a>{' '}
              &amp;
              <a href="https://twitter.com/DiversifyTechCo?ref_src=twsrc%5Etfw">
                @DiversifyTechCo
              </a>
              are doing an amazing job making sure that underrepresented
              individuals in tech are aware of available tech opportunities.
              <br />
              <br />
              Please make sure to follow and sign up for the newsletter.
            </p>
            &mdash; Ken Elliott | #WebDev #CX (@kennethspeaks){' '}
            <a href="https://twitter.com/kennethspeaks/status/1136276316846731264?ref_src=twsrc%5Etfw">
              June 5, 2019
            </a>
          </blockquote>
        </div>
        {/* <div class="p-6  w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 px-4">
          <blockquote class="twitter-tweet" data-cards="hidden" data-lang="en">
            <p lang="en" dir="ltr">
              Tfw you open{' '}
              <a href="https://twitter.com/venikunche?ref_src=twsrc%5Etfw">
                @venikunche
              </a>
              ’s newsletter and there’s way more exciting things than you can
              handle on a Thursday evening{' '}
            </p>
            &mdash; Camille C (@camofclay){' '}
            <a href="https://twitter.com/camofclay/status/1139339254197346309?ref_src=twsrc%5Etfw">
              June 14, 2019
            </a>
          </blockquote>
        </div> */}
      </div>

      <div className="text-center pt-6 pb-6 text-lg">
        <Link to="/join" className="text-black uppercase font-bold">
          Subscribe →
        </Link>
      </div>
    </div>
  )
}

export default WallOfLove
